import {createAction} from '@reduxjs/toolkit'
import {DiagnosticResponseType} from 'interfaces'

export const toggleEndpoint = createAction<{
  disableOption?: boolean
  debugMode?: boolean
  agentUUID: string
  userUUID: string
}>('toggleEndpoint')
export const toggleEndpointSuccess = createAction<string>(
  'toggleEndpointSuccess',
)
export const toggleEndpointFailure = createAction<string>(
  'toggleEndpointFailure',
)

export const getAssociatedUsers = createAction<{
  agentUUID: string
}>('getAssociatedUsers')
export const getAssociatedUsersSuccess = createAction<{
  users: {
    userId: string
    policyName: string
  }[]
}>('getAssociatedUsersSuccess')
export const getAssociatedUsersFailure = createAction<string>(
  'getAssociatedUsersFailure',
)

export const getDiagnosticResult = createAction<{
  agent: string
}>('getDiagnosticResult')
export const getDiagnosticResultSuccess = createAction<DiagnosticResponseType>(
  'getDiagnosticResultSuccess',
)
export const getDiagnosticResultFailure = createAction<string>(
  'getDiagnosticResultFailure',
)
